export const generateAppConfig = () => {
  let exportResult = {
    appRepoLocation: "https://sg-app.amantioman.com",
    backendUrl: "http://localhost:3100",
    jsReportUrl: "http://localhost:5488",
    travelAgentBackendUrl: "http://localhost:3000",
    adminRepoLocation: "http://localhost:3000",
    bookingAppRepoLocation: "http://localhost:3001",
  };
  if (process.env.REACT_APP_PRODUCTION_MODE === "TEST") {
    exportResult.appRepoLocation = "https://sg-app.singamata.com";
    exportResult.backendUrl = "https://sg-api.singamata.com/admin";
    exportResult.jsReportUrl = "https://sg-report.singamata.com";
    exportResult.travelAgentBackendUrl = "https://sg-api.singamata.com/business";
    exportResult.adminRepoLocation = "https://sg-admin.singamata.com";
    exportResult.bookingAppRepoLocation = "https://sg-booking.singamata.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "STAGE") {
    exportResult.appRepoLocation = "https://app.travoxis.com";
    exportResult.backendUrl = "https://admin-api.travoxis.com";
    exportResult.jsReportUrl = "https://report-test.amantioman.com.my";
    exportResult.travelAgentBackendUrl = "https://business-api.travoxis.com";
    exportResult.adminRepoLocation = "https://admin.travoxis.com";
    exportResult.bookingAppRepoLocation = "https://booking.travoxis.com";
  }
  if (process.env.REACT_APP_PRODUCTION_MODE === "PROD") {
    exportResult.appRepoLocation = "https://app.singamata.com";
    exportResult.backendUrl = "https://api.singamata.com/admin";
    exportResult.jsReportUrl= "https://report.singamata.com";
    exportResult.travelAgentBackendUrl =  "https://api.singamata.com/business";
    exportResult.adminRepoLocation = "https://admin.singamata.com";
    exportResult.bookingAppRepoLocation = "https://booking.singamata.com";
  }
  return exportResult;
};
